import {
  EB_CLEAR_SEARCH,
  EB_ENTITIES_FETCHED,
  EB_SEARCH_CRITERIA_SPECIFIED,
  EB_SEARCH_REQUEST_STARTED,
  EB_SEARCH_REQUEST_COMPLETED,
  RESET_CURRENT_SAVED_SEARCH,
  USER_SAVED_SEARCH_DIRTY,
  USER_SAVED_SEARCH_EDIT,
  USER_SAVED_SEARCH_EDIT_VIEW,
} from '../actions/EbSearchActions';

import { EB_DEFAULT_SCOPES, EMPLOYEE_RANGE_SEARCH } from 'lib/config/appConstants';

// Since the initial state should never change, it is wrapped in a function to prevent unintended modification.
const getInitialState = () => {
  const defaultSearchCriteria = {
    activityDateRange: {
      maxDate: null,
      // only recent data is shown by default
      minDate: new Date(new Date().getFullYear() - 2, 0, 1),
    },
    autocomplete: {},
    employeeRangeSearch: EMPLOYEE_RANGE_SEARCH,
    latitude: 0,
    longitude: 0,
    scopes: EB_DEFAULT_SCOPES, // default for EB is welfare/retirement
    searchOptions: {
      // We decided strict search would be best for narrowing searches, rather than the default.
      // This ensures you don't miss unexpected matches by default.
      matchAllTerms: false,
    },
    selected_states: [],
    state_county: [],
    userEnteredValue: '',
  };

  return {
    defaultSearchCriteria: defaultSearchCriteria,
    currentUserSavedSearch: null,
    ebEntities: [],
    isCurrentUserSavedSearchDirty: false,
    isFetchingEb: false,
    searchCriteria: { ...defaultSearchCriteria }, // Clone default search object
  };
};

function EbSearchState(state = getInitialState(), action) {
  switch (action.type) {
    case EB_ENTITIES_FETCHED:
      return {
        ...state,
        isFetching: false,
        ebEntities: action.entities,
      };
    case EB_SEARCH_CRITERIA_SPECIFIED:
      return {
        ...state,
        searchCriteria: action.searchCriteria,
      };
    case EB_CLEAR_SEARCH:
      return Object.assign(
        {
          savedSearches: state.savedSearches,
          favorites: state.favorites,
          userPreference: state.userPreference,
        },
        getInitialState()
      );
    case EB_SEARCH_REQUEST_STARTED:
      return {
        ...state,
        isFetchingEb: true,
      };
    case EB_SEARCH_REQUEST_COMPLETED:
      return {
        ...state,
        isFetchingEb: false,
      };
    case RESET_CURRENT_SAVED_SEARCH:
      return {
        ...state,
        currentUserSavedSearch: null,
        isCurrentUserSavedSearchDirty: false,
      };
    case USER_SAVED_SEARCH_EDIT:
      if (
        !action.savedSearch ||
        !action.savedSearch.content ||
        !action.savedSearch.content.webappSearchCriteria
      ) {
        console.log('Error - saved search is malformed, unable to edit');
        return {
          ...state,
        };
      }

      const newSearchCriteria = { ...action.savedSearch.content.webappSearchCriteria };
      return {
        ...state,
        currentUserSavedSearch: action.savedSearch,
        isCurrentUserSavedSearchDirty: false,
        searchCriteria: newSearchCriteria,
      };
    case USER_SAVED_SEARCH_EDIT_VIEW:
      if (!action.view) {
        console.log('Error - saved search - view is malformed, unable to edit');
        return {
          ...state,
        };
      }

      return {
        ...state,
        view: action.view,
      };
    case USER_SAVED_SEARCH_DIRTY:
      return {
        ...state,
        isCurrentUserSavedSearchDirty: action.dirtyFlag,
      };
    default:
      return state;
  }
}

export default EbSearchState;
